import React from 'react';
import { get } from 'lodash';
import { decodeQuery } from '@wix/communities-blog-client-common';
import AnimatedLoader from '../../../common/components/animated-loader';
import DefaultDesktopLayout from '../../../common/components/default-desktop-layout';
import Page from '../../../common/components/page';
import { connect } from '../../../common/components/runtime-context';
import { getIsSearchLoading } from '../../../common/store/is-loading/is-loading-selectors';
import { type AppState } from '../../../common/types';
import NoSearchResults from '../../components/no-search-results';
import SearchResultsList from '../../components/search-results-list';
import { getSearchResult } from '../../selectors/search-selectors';
import SearchPage from '../search-page';

type Props = ReturnType<typeof mapRuntimeToProps>;

const ResultsPage = ({ result, isLoading, query }: Props) => {
  const hasResults = Boolean(get(result, 'length', 0));

  const renderResults = () => {
    return hasResults ? <SearchResultsList posts={result} query={query} /> : <NoSearchResults />;
  };

  return (
    <Page noSpacing={!hasResults}>
      <DefaultDesktopLayout>
        <AnimatedLoader isLoading={isLoading}>
          {query ? renderResults() : <SearchPage />}
        </AnimatedLoader>
      </DefaultDesktopLayout>
    </Page>
  );
};

type OwnProps = {
  params?: { query?: string };
};

const mapRuntimeToProps = (state: AppState, ownProps: OwnProps) => ({
  result: getSearchResult(state),
  isLoading: getIsSearchLoading(state),
  query: decodeQuery(get(ownProps, 'params.query', '')),
});

export default connect(mapRuntimeToProps)(ResultsPage);
